// import React, { useEffect } from 'react';
import React, { useState, useEffect } from 'react';
// import lab from '../assets/img/portfolio/Labiconicslogo.png';
import lab from '../assets/img/lab_iconics_original_logo.png';
import { Navbar, Nav, Container } from 'react-bootstrap';
import SmallScreensNavbar from './smallscreennav';
import { useWindowWidthAndHeight } from './customhooks';
import './index.css'
import './../assets/scss/style_1.scss'
// import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { KeyboardArrowDown } from '@mui/icons-material'; 
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EastSharpIcon from '@mui/icons-material/EastSharp';


const Header = ({ handleNavClick, setHomeKey }) => {
    const [width, height] = useWindowWidthAndHeight();
    const [showDropdown, setShowDropdown] = useState(false);
    const [showSolutions, setShowSolutions] = useState(false);
    const [showIndustries, setShowIndustries] = useState(false);
    const [showResources, setShowResources] = useState(false);
    const [showCompay, setShowCompay] = useState(false);
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [isScrolled, setIsScrolled] = useState(false);
    let timeoutId = null;
    const location = useLocation();
    const isHomePage = location.pathname === '/';


    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            setIsScrolled(offset > 700);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const updateNavbarHeight = () => {
            const navbar = document.getElementById('header');
            if (navbar) {
                setNavbarHeight(navbar.offsetHeight);
            }
        };

        updateNavbarHeight('70px'); 
        window.addEventListener('resize', updateNavbarHeight);
        
        return () => window.removeEventListener('resize', updateNavbarHeight);
    }, []);

    const handleMouseEnter = (value) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        const offset = window.scrollY;
        
        setShowSolutions(value === 'solutions');
        setShowIndustries(value === 'industries');
        setShowResources(value === 'resources');
        setShowCompay(value === 'company');
    };

    const handleMouseLeave = () => {
        timeoutId = setTimeout(() => {
            setShowSolutions(false);
            setShowIndustries(false);
            setShowResources(false);
            setShowCompay(false);
        }, 100);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'instant'
        });
    };

    const SectionLink = ({ to, children }) => {
        // if (isHomePage && (to === '#lims-eln' || to ==='#lims' || to === '#eln'|| to === '#qms'|| to === '#dms'|| to === '#adbs'|| to === '#t-lims'|| to === '#saas')) {
        //     return (
        //         <ScrollLink 
        //             to={to.replace('#', '')} 
        //             spy={true} 
        //             smooth={true} 
        //             duration={0} 
        //             offset={-navbarHeight}
        //             className="sol-navLink"
        //         >
        //             {children}
        //         </ScrollLink>
        //     );
        // } else {
            if (to === '/blogs') {
                return (
                    <RouterLink 
                        to={to} 
                        className="sol-navLink"
                        onClick={() => setShowResources(false)}
                    >
                        {children}
                    </RouterLink>
                );
            }
            return (
                <RouterLink to={to.replace('#', '/')} className="sol-navLink" onClick={handleLinkClick}>
                    {children}
                </RouterLink>
            );
            
        // }
    };

    const handleLinkClick = () => {
        setShowSolutions(false);
        setShowIndustries(false);
        setShowResources(false);
        setShowCompay(false);
    }
    
    return (<div>
        <div className='d-none d-lg-block'>
            <header id="header" className={`fixed top-0 d-flex align-items-center transition-all duration-300 z-50 custom_header_scroll`}> 
                {/*  ${isScrolled ? 'custom_header_scroll' : ''} */}
                <div className="container d-flex align-items-center justify-content-between">
                    <div className="logo">
                        <h1>
                            <Nav.Link as={RouterLink} to="/" onClick={() => {
                                scrollToTop();
                                setHomeKey(prevKey => prevKey + 1);
                            }}>
                                <img src={lab} alt="Labiconics Logo" />
                            </Nav.Link>
                        </h1>
                    </div>
                    <Navbar expand="lg" variant="dark">
                        <Container>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-light" />
                            <Navbar.Collapse id="basic-navbar-nav mt-sm-5">
                                <Nav className="me-auto mt-auto navigation-bar">
                                    <Nav.Link as={RouterLink} to='/' href="HOME" className='smallermargin home-btn'  style={{fontSize:'14px', marginTop:'2px',marginRight:'5px', fontWeight:'100'}} 
                                    onClick={() => {
                                        scrollToTop();
                                        setHomeKey(prevKey => prevKey + 1);
                                    }}>
                                        <b>Home</b>
                                    </Nav.Link>
                                    {/* <Nav.Link as={Link} to='' href="#ABOUT" onClick={() => handleNavClick('home')}><b>ABOUT</b></Nav.Link> */}
                                    <div className="solutions-nav" 
                                        onMouseEnter={()=>handleMouseEnter('solutions')}
                                        onMouseLeave={()=>handleMouseLeave('solutions')}
                                    >
                                        Solutions <div className='arrow-svg'><KeyboardArrowDown style={{fontSize:'16px'}}/></div>
                                        {showSolutions && (
                                        <div className='solutions-items' style={{ top: `${navbarHeight}px`, width:'auto' }}>
                                            <div className='sol-items-desc'>
                                                <ul>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#lims' href="#Lims" >
                                                            <div className='sol-title'><span className="sol-title-text">LIMS</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            <p className='sol-data'>A digital backbone for the labs to improve quality, compliance and safety</p>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#eln' href="#Eln" >
                                                            <div className='sol-title'><span className="sol-title-text">ELN</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            <p className='sol-data'>A software tool specifically designed for scientists and researchers</p>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#qms' href="#QMS" >
                                                            <div className='sol-title'><span className="sol-title-text">QMS</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            <p className='sol-data'>This Software solution streamlines and automates quality control processes</p>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#adbs' href="#ADBS" >
                                                            <div className='sol-title'><span className="sol-title-text">ADBS</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            <p className='sol-data'>Is a software solution that automates the process of backing up important data</p>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#dms' href="#DMS" >
                                                            <div className='sol-title'><span className="sol-title-text">DMS</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            <p className='sol-data'>It is a cutting‐edge solution that automates the entire document lifecycle, from creation to archiving.</p>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#tlims' href="#T-LIMS" >
                                                            <div className='sol-title'><span className="sol-title-text">T-LIMS</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            <p className='sol-data'>A digital backbone for the labs to improve quality, compliance, safety and Testing</p>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#lims-eln' href="#LIMS-ELN">
                                                            <div className='sol-title'><span className='sol-title-text'>Integrated LIMS-ELN </span> <div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div> 
                                                            <p className='sol-data'>An all-in-one platform designed for laboratories for data management to experiment tracking</p>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='sol-navLink' to='#saas' href="#SAAS" >
                                                            <div className='sol-title'><span className="sol-title-text">SaaS</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            <p className='sol-data'>Provides a cost-effective, scalable LIMS without the need for any IT infrastructure.</p>
                                                        </SectionLink>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                    <div className="industries-nav" 
                                        onMouseEnter={()=>handleMouseEnter('industries')}
                                        onMouseLeave={()=>handleMouseLeave('industries')}
                                    >
                                        Industries <div className='arrow-svg'><KeyboardArrowDown style={{fontSize:'16px'}}/></div>
                                        {showIndustries && (
                                        <div className='industries-items' style={{ top: `${navbarHeight}px` }}>
                                            <div className='ind-items-desc'>
                                                <div className='bio-industries'>
                                                    <ul>
                                                        <li>
                                                            <SectionLink  className='sol-navLink' to='/pharma' href="#pharma" >
                                                                <p className='ind-title'><span className="ind-title-text">Pharmaceutical Industry</span></p>
                                                            </SectionLink >
                                                        </li>
                                                        <li>
                                                            <SectionLink  className='sol-navLink' to='/biotech' href="#biotech" >
                                                                <p className='ind-title'><span className="ind-title-text">Biotechnology Industry</span> </p>
                                                            </SectionLink >
                                                        </li>
                                                        <li>
                                                            <SectionLink  className='sol-navLink' to='/cro-cdmo' href="#cro-cdmo" >
                                                                <p className='ind-title'><span className="ind-title-text">CRO/CDMO</span> </p>
                                                            </SectionLink >
                                                        </li>
                                                        <li>
                                                            <SectionLink  className='sol-navLink' to='/foodindustry' href="#foodindustry" >
                                                                <p className='ind-title'><span className="ind-title-text">Food Technology Industry</span> </p>
                                                            </SectionLink >
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div style={{borderLeft:'1px solid black', height:'20vh'}}></div>
                                                <div className='academy'>
                                                    <ul>
                                                        <li>
                                                            <SectionLink className='sol-navLink' to='/academia' href="#academia" >
                                                                <p className='ind-title'><span className="ind-title-text">Academia</span></p>
                                                            </SectionLink>
                                                        </li>
                                                        <li>
                                                            <SectionLink className='sol-navLink' to='/startup' href="#startup" >
                                                                <p className='ind-title'><span className="ind-title-text">Start up</span></p>
                                                            </SectionLink>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                    <div className="resources-nav" 
                                        onMouseEnter={()=>handleMouseEnter('resources')}
                                        onMouseLeave={()=>handleMouseLeave('resources')}
                                    >
                                        Resources <div className='arrow-svg'><KeyboardArrowDown style={{fontSize:'16px'}}/></div>
                                        {showResources && (
                                        <div className='resources-items' style={{ top: `${navbarHeight}px` }}>
                                            <div className='res-items-desc'>
                                                <ul>
                                                    {/* <li>
                                                        <SectionLink className='res-navLink' to='/whitepapers' href="#whitepapers">
                                                            <div className='res-title'><span className="res-title-text">White Papers</span><div className='east-icon'><EastSharpIcon  style={{fontSize:'14px'}} /></div> </div>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='res-navLink' to='/webinars' href="#webinars">
                                                            <div className='res-title'><span className="res-title-text">Webinars</span> <div className='east-icon'><EastSharpIcon  style={{fontSize:'14px'}} /></div></div>
                                                        </SectionLink>
                                                    </li> */}
                                                    <li>
                                                        <SectionLink className='res-navLink' to='/blogs' href="#blogs" >
                                                            <div className='res-title'><span className="res-title-text">Blogs</span> <div className='east-icon'><EastSharpIcon  style={{fontSize:'14px'}} /></div></div>
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <RouterLink className='res-navLink' to='/downloads' href="#DOWNLOADS" >
                                                            <div className='res-title'><span className="res-title-text">Brochure</span> <div className='east-icon'><EastSharpIcon  style={{fontSize:'14px'}} /></div></div>
                                                        </RouterLink>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                    <div className="company-nav" 
                                        onMouseEnter={()=>handleMouseEnter('company')}
                                        onMouseLeave={()=>handleMouseLeave('company')}
                                    >
                                        Company <div className='arrow-svg'><KeyboardArrowDown style={{fontSize:'16px'}}/></div>
                                        {showCompay && (
                                        <div className='company-items' style={{ top: `${navbarHeight}px` }}>
                                            <div className='comp-items-desc'>
                                                <ul>
                                                    <li>
                                                        <SectionLink className='comp-navLink' to='/about' href="#LIMS-ELN">
                                                            <div className='comp-title'><span className="comp-title-text">About</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            {/* <p className='comp-data'>Learn about our company</p> */}
                                                        </SectionLink>
                                                    </li>
                                                    <li>
                                                        <SectionLink className='comp-navLink' to='/careers' href="#LIMS">
                                                            <div className='comp-title'><span className="comp-title-text">Careers</span><div className='east-icon'><div><EastSharpIcon  style={{fontSize:'14px'}} /></div></div></div>
                                                            {/* <p className='comp-data'>Help us keep our work to flow</p> */}
                                                        </SectionLink>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                    <div className="login-div">
                                        {/* <a target="_blank" rel="noopener noreferrer" href="https://qa.labiconics.support/" style={{textDecoration:'none'}}> */}
                                        <RouterLink to='/saas-form' style={{textDecoration:'none'}}>
                                            <div className='login-btn'>
                                                Subscribe
                                            </div>
                                        </RouterLink>
                                        {/* </a> */}
                                    </div>
                                    <div className="get_a_demo rounded-2">
                                        <RouterLink to='/demo' href='#REQUEST A DEMO' style={{textDecoration:'none'}}>
                                           <div className="demo_navLink">
                                                <button className='bg-transparent' style={{border:'none', color:'#04346fcc', fontWeight:'bold'}}>
                                                    <div className='demo_title'>Get a Demo</div>
                                                </button>
                                                <div className="arrow arrow--right">
                                                    <span></span>
                                                </div>
                                           </div>
                                        </RouterLink>
                                    </div>
                                </Nav>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </div>
            </header>
        </div>

        <div className='d-sm-block d-lg-none fixed-top'>
            <div>
                <div className="header-inner" id='header'>
                    <div className="logo">
                        <h1>
                            <a href="/">
                                <img src={lab} alt="Labiconics Logo" style={{ width: '50vw' }} />
                            </a>
                        </h1>
                    </div>
                    <SmallScreensNavbar navClass="nav-small"
                        linkClassName="nav-small-link" handleNavClick={handleNavClick}
                    />
                </div>
            </div>
        </div>
    </div>
    );
};

export default Header;


